module.exports = __webpack_public_path__ + "img/vip-diamond-fill.028265be.svg";